import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedPlan: null,
	billingType: 'yearly',
	subscriptionCompleted: false,
};

const subscriptionSlice = createSlice({
	name: 'subscription',

	initialState,

	reducers: {
		setPlan: (state, action) => {
			state.selectedPlan = action.payload;
		},

		setBillingType: (state, action) => {
			state.billingType = action.payload;
		},

		setSubscriptionCompleted: (state, action) => {
			state.subscriptionCompleted = action.payload;
		},

		clearSubscription: (state) => {
			state.selectedPlan = null;
			state.billingType = 'yearly';
			state.subscriptionCompleted = false;
		},
	},
});

export const { setPlan, setBillingType, setSubscriptionCompleted, clearSubscription } =
	subscriptionSlice.actions;

export default subscriptionSlice.reducer;
